// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-form-field {
  width: 100%;
  margin-bottom: 0 !important;
}

::ng-deep .mat-form-field-wrapper {
  padding-bottom: 10px !important;
  margin-bottom: 10px !important;
}

::ng-deep .mat-form-field-subscript-wrapper {
  display: none !important;
}

.error,
small {
  display: block;
  margin-top: 4px;
  line-height: 1.2;
}

.error {
  color: #f44336;
}

::ng-deep .mat-dialog-container {
  border-radius: 16px !important;
  padding: 16px !important;
}

:host ::ng-deep * {
  font-family: "Roboto", sans-serif !important;
}

.add-member-btn {
  color: #1288ff;
  font-weight: 700;
  font-size: 14px;
  border: 1px solid #1288ff;
  background-color: transparent !important;
  border-radius: 24px;
}

.save-btn {
  background: linear-gradient(90deg, #00b2ff 0%, #1288ff 100%) !important;
  color: white !important;
  border-radius: 24px !important;
  font-size: 14px;
  font-weight: 600;
  border: none;
}

.card-bg {
  background-color: #f7f7f7;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
}

.dependent-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.dependent-label {
  font-size: 16px;
  font-weight: 400;
  color: #1c1c1c;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/careplus/careplus-add-customers-detail/careplus-add-customers-detail.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,uEAAuE;EACvE,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wqFAAwqF","sourcesContent":["mat-form-field {\n  width: 100%;\n  margin-bottom: 0 !important;\n}\n\n::ng-deep .mat-form-field-wrapper {\n  padding-bottom: 10px !important;\n  margin-bottom: 10px !important;\n}\n\n::ng-deep .mat-form-field-subscript-wrapper {\n  display: none !important;\n}\n\n.error,\nsmall {\n  display: block;\n  margin-top: 4px;\n  line-height: 1.2;\n}\n\n.error {\n  color: #f44336;\n}\n\n::ng-deep .mat-dialog-container {\n  border-radius: 16px !important;\n  padding: 16px !important;\n}\n\n:host ::ng-deep * {\n  font-family: \"Roboto\", sans-serif !important;\n}\n\n.add-member-btn {\n  color: #1288ff;\n  font-weight: 700;\n  font-size: 14px;\n  border: 1px solid #1288ff;\n  background-color: transparent !important;\n  border-radius: 24px;\n}\n\n.save-btn {\n  background: linear-gradient(90deg, #00b2ff 0%, #1288ff 100%) !important;\n  color: white !important;\n  border-radius: 24px !important;\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n}\n\n.card-bg {\n  background-color: #f7f7f7;\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 24px;\n}\n\n.dependent-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n}\n\n.dependent-label {\n  font-size: 16px;\n  font-weight: 400;\n  color: #1c1c1c;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
